class DeliveryTime extends HTMLElement {
  constructor() {
    super();
    this._timer = null;
    this._inited = false;
  }

  connectedCallback() {
    if (this._inited) return;
    this._inited = true;

    // Ensure it can display even if theme adds d-none
    this.classList.remove("d-none");
    this.style.display = "block";

    // Read settings from attributes
    this.formatString = this.getAttribute("data-frm-day") || "d, DD MMM";
    this.excludedDays = (this.getAttribute("data-exclude-day") || "")
      .replace(/ /g, "")
      .split(",")
      .filter(Boolean);

    this.numbDateStart = this.getAttribute("data-estimate-start") || "0";
    this.numbDateEnd = this.getAttribute("data-estimate-end") || "0";
    this.targetTime = this.getAttribute("data-time") || "16:00:00";

    // Elements to populate
    this.hr = this.querySelector(".productView-dlvr__remaining-hr");
    this.mins = this.querySelector(".productView-dlvr__remaining-mins");

    // Locale from <html lang="...">
    this.iso_code = document.documentElement.lang || "en-US";

    // Populate delivery date range + initial countdown
    this.productDeliveryTime();
    this.renderCountdown();

    // Keep countdown updated
    this._timer = setInterval(() => this.renderCountdown(), 1000);
  }

  disconnectedCallback() {
    if (this._timer) clearInterval(this._timer);
    this._timer = null;
    this._inited = false;
  }

  renderCountdown() {
    const countdown = this.countdownToTime(this.targetTime);
    if (this.hr) this.hr.innerHTML = countdown.hours;
    if (this.mins) this.mins.innerHTML = countdown.minutes;
  }

  // ---------- Excluded days helpers ----------

  isExcludedDay(dateObj) {
    const dayName = ["SUN", "MON", "TUE", "WED", "THU", "FRI", "SAT"][dateObj.getDay()];
    return this.excludedDays.includes(dayName);
  }

  parseTimeParts(timeStr) {
    const parts = (timeStr || "").split(":");
    return {
      h: parseInt(parts[0] || "0", 10),
      m: parseInt(parts[1] || "0", 10),
      s: parseInt(parts[2] || "0", 10),
    };
  }

  getNextCutoffDateTime(targetTime) {
    const now = new Date();
    const { h, m, s } = this.parseTimeParts(targetTime);

    // Create cutoff datetime for today
    const cutoff = new Date(now);
    cutoff.setHours(h, m, s, 0);

    // If today is excluded OR we are past cutoff, start from tomorrow at cutoff time
    if (this.isExcludedDay(now) || cutoff <= now) {
      cutoff.setDate(cutoff.getDate() + 1);
      cutoff.setHours(h, m, s, 0);
    }

    // Move forward until cutoff lands on a non-excluded day
    while (this.isExcludedDay(cutoff)) {
      cutoff.setDate(cutoff.getDate() + 1);
      cutoff.setHours(h, m, s, 0);
    }

    return cutoff;
  }

  countdownToTime(targetTime) {
    const now = new Date();
    const cutoff = this.getNextCutoffDateTime(targetTime);

    const remainingTime = cutoff - now;
    const totalMinutes = Math.max(0, Math.floor(remainingTime / (1000 * 60)));

    const hours = Math.floor(totalMinutes / 60);
    const minutes = totalMinutes % 60;

    return { hours, minutes };
  }

  // ---------- Delivery estimate dates ----------

  productDeliveryTime() {
    const orderDlvr = document.querySelectorAll("[data-delivery-time]");
    if (!orderDlvr.length) return;

    const startDay = this.excludeDays(this.excludedDays, this.numbDateStart);
    const endDay = this.excludeDays(this.excludedDays, this.numbDateEnd);

    const formattedStartDate = this.formatDate(startDay, this.formatString);
    const formattedEndDate = this.formatDate(endDay, this.formatString);

    orderDlvr.forEach((el) => {
      const startEl = el.querySelector("[data-start-delivery]");
      const endEl = el.querySelector("[data-end-delivery]");

      if (startEl) startEl.innerHTML = formattedStartDate;
      if (endEl) endEl.innerHTML = formattedEndDate;
    });
  }

  // Count forward "dataRange" working days, skipping excluded days.
  // Also: if today is excluded, start from the next working day.
  excludeDays(excludedDays, dataRange) {
    const d = new Date();
    const offset = parseInt(dataRange || "0", 10);

    // If today is excluded, start from the next working day
    while (this.isExcludedDay(d)) {
      d.setDate(d.getDate() + 1);
    }

    let added = 0;
    while (added < offset) {
      d.setDate(d.getDate() + 1);
      if (!this.isExcludedDay(d)) added++;
    }

    return d.toLocaleDateString("en-US");
  }

  formatDate(dateString, formatString) {
    const date = new Date(dateString);
    const locale = this.iso_code || "en-US";

    const dayOfWeek = date.toLocaleDateString(locale, { weekday: "long" });
    const dayOfMonth = date.toLocaleDateString(locale, { day: "2-digit" });
    const month = date.toLocaleDateString(locale, { month: "short" });
    const monthNumber = String(date.getMonth() + 1).padStart(2, "0");
    const year = date.toLocaleDateString(locale, { year: "numeric" });

    return (formatString || "")
      .replace("d", dayOfWeek)
      .replace("DD", dayOfMonth)
      .replace("MMM", month)
      .replace("MM", monthNumber)
      .replace("YYYY", year);
  }
}

customElements.define("delivery-time", DeliveryTime);
